/**
 * Delta-based widget grid resize (dashboard / home canvas).
 * Uses movement from mousedown so a click or crossing another widget does not jump to full width.
 */
export function calculateWidgetResizeSpans({
  resizeHandle,
  resizeStartPosition,
  startColumnSpan,
  startRowSpan,
  widgetX = 0,
  clientX,
  clientY,
  canvasRect,
  maxRowSpan = 6,
}) {
  const canvasWidth = canvasRect.width;
  const gridCellWidth = (canvasWidth - 11 * 20) / 12;
  const gridRowHeight = 120;
  const colUnit = gridCellWidth + 20;
  const rowUnit = gridRowHeight + 20;

  const maxColumns = 12 - widgetX;
  let newColumnSpan = startColumnSpan;
  let newRowSpan = startRowSpan;

  if (resizeHandle.includes('right')) {
    const deltaX = clientX - resizeStartPosition.x;
    const colChange = Math.round(deltaX / colUnit);
    newColumnSpan = Math.max(1, Math.min(maxColumns, startColumnSpan + colChange));
    if (widgetX + newColumnSpan > 12) {
      newColumnSpan = 12 - widgetX;
    }
  }

  if (resizeHandle.includes('bottom')) {
    const deltaY = clientY - resizeStartPosition.y;
    const rowChange = Math.round(deltaY / rowUnit);
    newRowSpan = Math.max(1, Math.min(startRowSpan + rowChange, maxRowSpan));
  }

  return { column_span: newColumnSpan, row_span: newRowSpan };
}
